import { getAccessToken } from '../../auth/service/storage.service';
import { API_URL } from '../../common/utils';

/**
 * Crea una guía de envío para PaqueteExpress
 * @param deliveryId ID de la entrega
 * @param totalWeight Peso total del envío
 * @param quantityPackages Cantidad de paquetes
 * @returns Promesa con la respuesta del servicio
 */
export const createGuide = async (deliveryId: string, totalWeight: number, quantityPackages: number): Promise<any> => {
  try {
    const token = getAccessToken();
    
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }
    
    const response = await fetch(`${API_URL}/paquetexpress/create-guide`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ 
        deliveryId, 
        totalWeight, 
        quantityPackages 
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({
        message: response.statusText,
        error: 'Bad Request',
        statusCode: response.status
      }));
      throw new Error(`Error al crear guía: ${errorData ? errorData.message : response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error al crear guía:', error);
    throw error;
  }
};

/**
 * Cancela una guía de envío de PaqueteExpress
 * @param trackingNumber Número de seguimiento de la guía
 * @returns Promesa con la respuesta del servicio
 */
export const cancelGuide = async (trackingNumber: string): Promise<any> => {
  try {
    const token = getAccessToken();
    
    if (!token) {
      throw new Error('No se encontró token de autenticación');
    }
    
    const response = await fetch(`${API_URL}/paquetexpress/cancel-guide`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ trackingNumber })
    });
    
    if (!response.ok) {
      throw new Error(`Error al cancelar guía: ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error al cancelar guía:', error);
    throw error;
  }
}; 